import type { ReactNode } from 'react';
import { Box } from '@customerio/pluma-components/react';

/**
 * Keeps a click inside an editable cell from reaching the row.
 *
 * A row in this table is clickable: clicking one selects it. An editor lives
 * inside a row, so every click meant for the editor would also toggle that
 * selection, and the first click on "Add description" would select the row
 * instead of opening the box.
 */

export type RowClickGuardProps = {
  children: ReactNode;
};

export function RowClickGuard({ children }: RowClickGuardProps) {
  return <Box onClick={(event) => event.stopPropagation()}>{children}</Box>;
}
